export default "__VITE_ASSET__BgL7oEJE__"